import React, {useEffect, useState} from 'react';
import {useIntl} from "react-intl";
import {RequestVisitorSearchCondition} from "../../../../../modules/vms/dto/RequestVisitorSearchCondition";
import {Grid, Stack} from "@mui/material";
import FormFieldText from "../../../../../components/FormFieldText";
import FormFieldSelect from "../../../../../components/FormFieldSelect";
import SearchButton from "../../../../../components/buttons/SearchButton";
import {VisitorStatus} from "../../../../../modules/vms/enums/VisitorStatus";

export type SearchConditionProps = {
    searchCondition: RequestVisitorSearchCondition;
    onChange: (name: string, value: any) => void;
    onSearch: () => void;
};

const SearchCondition: React.FC<SearchConditionProps> = (props) => {
    const intl = useIntl();

    useEffect(() => {
    }, []);

    return (
        <Grid container columnSpacing={2} alignItems="center">
            <Grid item xs={2}>
                <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_NAME"})}
                               value={props.searchCondition.visitorName}
                               onChange={(value) => {
                                   props.onChange("visitorName", value)
                               }}/>
            </Grid>

            <Grid item xs={2}>
                <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_MOBILE"})}
                               value={props.searchCondition.visitorMobile}
                               onChange={(value) => {
                                   props.onChange("visitorMobile", value)
                               }}/>
            </Grid>
            <Grid item xs={2}>
                <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_COMPANY"})}
                               value={props.searchCondition.visitorCompany}
                               onChange={(value) => {
                                   props.onChange("visitorCompany", value)
                               }}/>
            </Grid>

            <Grid item xs={2}>
                <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_NAME"})}
                               value={props.searchCondition.hostName}
                               onChange={(value) => {
                                   props.onChange("hostName", value)
                               }}/>
            </Grid>
            {/*<Grid item xs={2}>*/}
            {/*    <FormFieldText label={intl.formatMessage({id: "VMS_VISIT_REQUEST_HOST_DEPARTMENT_NAME"})}*/}
            {/*                   value={props.searchCondition.hostDepartmentName}*/}
            {/*                   onChange={(value) => {*/}
            {/*                       props.onChange("hostDepartmentName", value)*/}
            {/*                   }}/>*/}
            {/*</Grid>*/}

            {/*<Grid item xs={2}>*/}
            {/*    <FormFieldText label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_VISIT_CODE"})}*/}
            {/*                   value={props.searchCondition.visitCode}*/}
            {/*                   onChange={(value) => {*/}
            {/*                       props.onChange("visitCode", value)*/}
            {/*                   }}/>*/}
            {/*</Grid>*/}
            <Grid item xs={2}>
                <FormFieldSelect label={intl.formatMessage({id: "VMS_REQUEST_VISITOR_STATUS"})}
                                 value={props.searchCondition.visitorStatus}
                                 onChange={(value) => {
                                     props.onChange("visitorStatus", value)
                                 }}
                                 items={VisitorStatus.List.map((item) => {
                                     return {label:intl.formatMessage({id:  item.label}), value: item.value}
                                 })}/>

            </Grid>
            <Grid item xs={2}>
                <Stack direction={'row'} spacing={2}>
                    <SearchButton onClick={() => props.onSearch()}/>
                </Stack>
            </Grid>
        </Grid>
    );
};

export default SearchCondition;
